import { Box, Tabs, TabsProps } from '@mui/material';
import classNames from 'classnames/bind';
import styles from './BaseTabList.module.scss'

type BaseTabListProps = TabsProps

const cx = classNames.bind(styles);

const BaseTabList = (props: BaseTabListProps) => {
  return (
    <Box className={cx("tab-list-container")}>
      <Tabs {...props}>
        {props.children}
      </Tabs>
    </Box>
  )
}

export default BaseTabList
